import React from "react";
import { Field, reduxForm } from "redux-form";

import Input from "../../../../../../../components/common/input/Input";
import Select2 from "../../../../../../../components/common/select/Select2";
import Button from "../../../../../../../components/common/button/Button";
import {
  required,
  alphaNumericSpace,
  email,
  dropdown
} from "../../../../../../../utils/forms/validators";
import { ADMIN_ADD_REFERENCE_FORM } from "../../../../../../../actions/admin.actions";

const name = alphaNumericSpace("Please enter a valid Name.");
const mail = email("Please enter a valid email address.");
const relationship = dropdown("Please select an relationship.");

import styles from "./NewReference.scss";

class NewReference extends React.Component {
  render() {
    return (
      <form className={styles.newReference} onSubmit={this.props.handleSubmit}>
        <div className={styles.title}>Add a New Reference for Member</div>
        <div className={styles.form}>
          <div className={styles.input}>
            <Field
              name="name"
              type="text"
              placeholder="Name"
              component={Input}
              validate={[required, name]}
            />
          </div>

          <div className={styles.input}>
            <Field
              name="email"
              type="text"
              placeholder="Email"
              component={Input}
              validate={[required, mail]}
            />
          </div>

          <div className={styles.input}>
            <Field
              name="relationship_id"
              type="select"
              placeholder="Relationship"
              component={Select2}
              options={this.props.workRelations}
              validate={[required, relationship]}
            />
          </div>
        </div>

        <div className={styles.button}>
          <Button
            isPrimary
            type="submit"
            size="large"
            label="SEND REFERENCE REQUEST"
            isDisabled={this.props.invalid}
          />
        </div>
      </form>
    );
  }
}

export default reduxForm({
  form: ADMIN_ADD_REFERENCE_FORM
})(NewReference);



// WEBPACK FOOTER //
// ./src/routes/admin/memberApprovedProfile/profile/components/references/newReference/NewReference.js